import {Component, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {Project} from '../model/project';
import {CurrentContext} from '../model/currentContext';
import {Questionnaire} from '../model/questionnaire';
import {Terminal} from '../model/terminal';
import {ContextMenuComponent} from '../context-menu/context-menu.component';
import {ImportDuplicateModalComponent} from '../import-duplicate-modal/import-duplicate-modal.component';
import {ProjectLevel, ProjectLevelUtil} from '../model/projectLevelEnum';
import {ImportOption} from '../model/importOptionEnum';
import {ImportRequirement} from '../model/import-requirement';
import {ProjectService} from '../project/project.service';
import {SharedRefreshService} from '../service/sharedRefreshService';
import {FileToDownload} from '../model/file-to-download';
import {StringUtil} from '../util/stringUtil';
import {NotepadComponent} from '../notepadApp/notepad.component';
import {TerminalUtil} from '../util/terminalUtil';
import {ServerAddress} from '../util/server-address';
import {Device} from '../model/device';

@Component({
  selector:'present-by-large-icons',
  template:`
      <div *ngIf="this.viewMode === 'list'" class="table">
        <div class='theader col-md-12'>
          <div class='table_header'>Name</div>
          <div class='table_header'>Date Modified</div>
          <div *ngIf="!ListOfRegisteredDevices" class='table_header'>Size</div>
          <div class='table_header'>Kind</div>
        </div>
      </div>
      <div [className]="selectViewMode()">
        <div class="filecontent">
          <ng-container *ngIf="this.projectExploded">
            <div *ngFor="let project of projectList"  (dblclick)="explode(project)" class="file device">
              <div class="mainwrapper">
                <div class="icon"></div>
                <div class="title">{{project.name}}</div>
              </div>
              <div *ngIf="this.viewMode != 'large'" class="infowrapper hideable">
                <div class="lastModified">{{getHumanReadableTime(project.lastModifiedDate)}}</div>
                <div class="size"></div>
                <div class="filetype">Project</div>
              </div>
            </div>
            </ng-container>

          <ng-container *ngIf="this.questionnaireExploded">
            <div *ngFor="let quest of questList" data-node-type="questionnaire" (contextmenu)="onRightClick($event,quest)" (dblclick)="explode(quest)" class="file dir">
              <div class="mainwrapper">
                <div class="icon"></div>
                <div class="title">{{quest.name}}</div>
              </div>
              <div *ngIf="this.viewMode != 'large'" class="infowrapper hideable">
                <div class="lastModified">{{getHumanReadableTime(quest.lastModifiedDate)}}</div>
                <div class="size"></div>
                <div class="filetype">Questionnaire</div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="this.terminalExploded">
            <div  class="file dir"  data-node-type="file"  [className]="getClassName(selectedQuestionnaire.src)">
              <div class="mainwrapper">
                <div class="icon"></div>
                <div class="title">{{selectedQuestionnaire.name}}</div>
              </div>
              <div *ngIf="this.viewMode != 'large'" class="infowrapper hideable">
                <div class="lastModified"></div>
                <div class="size"></div>
                <div class="filetype">JSON</div>
              </div>
            </div>
            <div *ngFor="let term of termList"  data-node-type="terminal" (contextmenu)="onRightClick($event,term)" (dblclick)="explode(term)" class="file dir">
              <div class="mainwrapper">
                <div class="icon"></div>
                <div class="title">{{term.name}}</div>
              </div>
              <div *ngIf="this.viewMode != 'large'" class="infowrapper hideable">
                <div class="lastModified">{{getHumanReadableTime(term.lastModifiedDate)}}</div>
                <div class="size"></div>
                <div class="filetype">{{term.src}}</div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="this.terminalDiscovery">
            <div *ngFor="let fic of selectedTerminal.filesToDownload" [className]="getClassName(fic.src)" data-node-type="file"   (dblclick)="preparePreview(fic.src)" (contextmenu)="onRightClick($event,fic)"  >
              <div class="mainwrapper">
                <div class="icon"></div>
                <div class="title">{{fic.src}}</div>
              </div>
              <div *ngIf="this.viewMode != 'large'" class="infowrapper hideable">
                <div class="lastModified">{{getHumanReadableTime(fic.timestamp)}}</div>
                <div class="size">{{fic.size}}B</div>
                <div class="filetype">{{fic.type}}</div>
                <div class="filetype">{{fic.type}}</div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="ListOfRegisteredDevices">
            <div *ngFor="let device of devices" class="file device">
              <div class="mainwrapper">
                <div class="icon"></div>
                <div class="title">{{device.name}}</div>
              </div>
              <div *ngIf="this.viewMode != 'large'" class="infowrapper hideable">
                <div class="lastModified">{{getHumanReadableTime(device.createdDate)}}</div>
                <div *ngIf="!ListOfRegisteredDevices" class="size"></div>
                <div class="filetype">Device</div>
              </div>
            </div>
          </ng-container>
        </div>
        <ng-container *ngIf="showContext == true">
          <context-menu [top]="y" [left]="x" (import)="onImport()"></context-menu>
        </ng-container>
      </div>
      <generic-info-modal  [hide]="_hide" [statusCode]="_statusCode" [title]="_modalTitle" [text]="_modalText" (OkClick)="onOk()"></generic-info-modal>
      <notepad></notepad>
      <import-duplicate-modal (importOptions)="onExecuteImport($event)"></import-duplicate-modal>
  `,
  styles:[`

    .theader {
      display: table-cell;
      border-bottom: #ccc 1px solid;
      border-top: #ccc 1px solid;
      background: #bdbdbd;
      color: #e5e5e5;
      padding-top: 10px;
      padding-bottom: 10px;
      font-weight: 700;
    }

    .table {
      display: table;
      text-align: center;
      width: 100%;
      margin: 10px auto 0;
      border-collapse: separate;
      font-family: 'Roboto', sans-serif;
      font-weight: 400;
    }

    .theader {
      display: table-row;
    }

    .table_header {
      display: table-cell;
      border-bottom: #ccc 1px solid;
      border-top: #ccc 1px solid;
      background-image: linear-gradient(to right, #e9eef1 0%, #f0f0f0 100%);
      color: #0f0f0f;
      border-right: #e6e6e6 2px solid;
      padding-top: 10px;
      padding-bottom: 10px;
      font-weight: 700;
    }

    .table_header:first-child {
      border-left: #ccc 1px solid;
      border-top-left-radius: 5px;
      width: 41%;
    }

    .table_header:last-child {
      border-right: #ccc 1px solid;
      border-top-right-radius: 5px;
    }


    .tablet .filecontent .file {
      display: flex;
      width: 100%;
      height: 2vw;
      padding: 0;
      align-items: center;
    }

    .tablet .file .mainwrapper, .tablet .file .infowrapper {
      display: block;
      position: relative;
      height: 100%;
      width: 40.55%;
      line-height: 2vw;
    }

    .tablet .file .infowrapper {
      display: block;
      position: relative;
      width: 59%;
      line-height: 2vw;
    }

  .filecontent{
    overflow:auto;
    width:100%;
    flex-grow:1;
    padding:5px;
  }

  .filecontent .file{
    display:block;
    position:relative;
    float:left;
    width:6vw;
    height:8vw;
    padding:0.5vw;
    padding-top:0;
  }

  .tableheader {
    z-index: 100;
    background-color: white;
    border-bottom: 1px solid #f5f5f5;
    margin-bottom: 0.5em;
    color: #777;
  }

  .tableheader .icon{display:none !important;}

  .grid .hideable{
    display:none !important;
  }

  .filecontent .file:not(.tableheader):hover{
    background-color:#eee;
  }


  .file .lastModified, .file .filetype, .file .size{
    display: block;
    position: relative;
    float:left;
    height: 100%;
    width: 10%;
    border-left:1px solid #e5e5e5;
    box-sizing:border-box;
    text-indent:1em;
    text-overflow:ellipsis;
    overflow:hidden;
    white-space:nowrap;
    font-size: 90%;
  }

  .file .size{
    width:19%;
  }
    .file .lastModified{
      width:61.5%;
    }

  div[data-title]:before {
    content: attr(data-title);
    display: block;
    position: absolute;
    bottom: 0;
    margin-bottom: 4.8em;
    font-size: 0.7vw;
    color: white;
    background-color: #111;
    padding: 0.2vw 0.4vw;
    min-width: 4vw;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    transition: opacity 300ms;
    pointer-events: none;
    text-align: center;
  }

  div[data-title]:hover:before{
    opacity:1;
    transition-delay:1s;
  }

  #infocorner div[data-title]:hover:before{
    opacity:1;
    transition-delay:300ms;
  }
  .grid .hideable{
    display:none !important;
  }


  .yell{
    text-transform: uppercase;
  }

  .file.doc .icon, .file.unknown .icon, .file.misc .icon{
    background-image:url("../../assets/images/filesprite.png") !important;
  }

  .file .icon{
    width:6em;
    height:6em;
    background-image:url("../../assets/images/filesprite2.png") !important;
    background-size:1100% 100%;
  }


  .filecontent{
    overflow:hidden;
    width:100%;
    flex-grow:1;
    padding:5px;
  }

  .filecontent .file{
    display:block;
    position:relative;
    float:left;
    width:6vw;
    height:8vw;
    padding:0.5vw;
    padding-top:0;
  }

  .tableheader {
    z-index: 100;
    background-color: white;
    border-bottom: 1px solid #f5f5f5;
    margin-bottom: 0.5em;
    color: #777;
  }

  .tableheader .icon{display:none !important;}

  .grid .hideable{
    display:none !important;
  }

  .tablet .filecontent .file .icon {
    display: block;
    float: left;
    width: 1.5em;
    height: 1.5em;
    margin: 0.25em;
    margin-right: 0.5em;
  }

  .desktoplink.file > .icon{
    background-size: 44vw 4vw;
    width: 4vw;
    height: 4vw;
    margin: 0 0.5vw;
  }

  .doc.css .icon{background-position:10% 0;}
  .doc.js .icon{background-position:20% 0;}
  .doc.html .icon{background-position:30% 0;}
  .doc.java .icon{background-position:40% 0;}
  .doc.hs .icon{background-position:50% 0;}
  .doc.ahk .icon{background-position:60% 0;}
  .doc.py .icon{background-position:70% 0;}
  .doc.txt .icon{background-position:80% 0;}
  .doc.json .icon{background-position:90% 0;}
  .doc.zip .icon{background-position:100% 0;}

  .audio .icon{background-position:10% 0;}
  .font .icon{background-position:20% 0;}
  .dir .icon{background-position:30% 0;}
  .device .icon{background-position:40% 0;}

  .file .title {
    height: 2.5em;
    text-align: center;
    word-wrap: break-word;
    overflow: hidden;
    font-size: 90%;
  }

  .table .file .title {
    margin-left: 0.5vw;
    height:100%;
    text-overflow: ellipsis;
    text-align: left;
    white-space: nowrap;
  }`]
})

export class PresentByLargeIconsComponent {

  @Input('projectList') projectList:Project[];
  @Input() targetName:string;
  @Input() context:CurrentContext;
  @Input() viewMode:string;
  @Input() devices:Device[];

  private projectExploded = true;
  private questionnaireExploded = false;
  private terminalExploded = false;
  private ListOfRegisteredDevices = false;

  private questList:Questionnaire[];
  private termList:Terminal[];
  private _selectedFile:FileToDownload;
  private showContext= false;

  private selectedProject = new Project();
  private selectedQuestionnaire = new Questionnaire();
  private selectedTerminal = new Terminal();

  private x:number;
  private y:number;

  // TODO: replace this with function call
  private _modalTitle;
  private _modalText:string;
  private _hide = true;
  private _statusCode = 200;

  private terminalDiscovery = false;

  constructor(private _projectService:ProjectService,private _refreshService:SharedRefreshService) {
    window.addEventListener('contextmenu', e => {
      event.preventDefault();
    });
    window.addEventListener('click',e=> {
      this.showContext = false;
    });
  }

  @ViewChild(ContextMenuComponent) private contextMenu:ContextMenuComponent;
  @ViewChild(ImportDuplicateModalComponent) private importModal:ImportDuplicateModalComponent;
  @ViewChild(NotepadComponent) private notepadComponent:NotepadComponent;


  private getHumanReadableTime(uhr:(string|number)):string {
    return StringUtil.unixTimeStampToHumanReadable(uhr);
  }

  explode(object:(Questionnaire|Project|Terminal)) {
    if(this.projectExploded) {
      this.questionnaireExploded = true;
      this.projectExploded = false;
      if(object instanceof  Project) {
        this.selectedProject = object;
        this.questList = object.questionnaires;
      }
      return;
    }

    if(this.questionnaireExploded) {
      this.terminalExploded = true;
      this.questionnaireExploded = false;
      if(object instanceof  Questionnaire) {
        this.selectedQuestionnaire = object;
        this.termList = object.terminals;
      }
      return;
    }

    if(this.terminalExploded) {
      this.terminalExploded = false;
      this.questionnaireExploded = false;
      this.terminalDiscovery = true;
      if(object instanceof  Terminal) {
        this.selectedTerminal  = object;
      }
      return;
    }
  }

  getClassName(src: string):string {
    if(src.includes('.jpg')) {
      return 'file img jpg';
    }
    if(src.includes('.png')) {
      return 'file img png';
    }
    if(src.includes('.bmp')) {
      return 'file img jpg';
    }
    if(src.includes('.json')) {
      return 'file doc json';
    }if(src.includes('.html')) {
      return 'file doc html';
    } if(src.includes('.css')) {
      return 'file doc css';
    } if(src.includes('.txt')) {
      return 'file doc txt';
    }if(src.includes('.xml')) {
      return 'file doc xml';
    }
    return 'file dir';
  }


  navigate(index:number) {
    if (this.terminalExploded && index === -1) {
      this.terminalExploded = false;
      this.questionnaireExploded = true;
      return;
    }
    if (this.questionnaireExploded && index === -1) {
      this.projectExploded = true;
      this.questionnaireExploded = false;
      return;
    }
    if (this.questionnaireExploded && index === 1) {
      this.terminalExploded = true;
      this.questionnaireExploded = false;
      return;
    }
    if (this.projectExploded && index === 1) {
      this.projectExploded = false;
      this.questionnaireExploded = true;
      return;
    }
    if (this.terminalDiscovery && index === -1) {
      this.terminalExploded = true;
      this.terminalDiscovery = false;
      return;
    }
  }


  selectViewMode():string {
    if(this.viewMode === 'list') {
      return 'tablet';
    }
    return '';
  }


  onRightClick(event: MouseEvent,obj:(Terminal|Questionnaire|FileToDownload)) {

    if(obj instanceof Terminal) {
      this.selectedTerminal = obj;
    } else if(obj instanceof FileToDownload) {
      this._selectedFile = obj;
    } else if(obj instanceof Questionnaire) {
      this.selectedQuestionnaire = obj;
    }

      /*const origin = {
        left: e.pageX,
        top: e.pageY
      };*/
      console.log('clientX'+ event.clientX);
      console.log('clientY'+event.clientY);
      console.log('pageX'+event.pageX);
      console.log('pageY'+event.pageY);
      console.log('screenX'+event.screenX);
      console.log('screenY'+event.screenY);
      console.log('offsetX'+event.offsetX);
      console.log('offsetY'+event.offsetY);
       const elm = event.currentTarget as HTMLInputElement;
       if(this.viewMode !=='list') {
         this.x = (elm.offsetLeft+50);
         this.y = (elm.offsetTop+50);
       } else {
        this.x = (event.offsetX);
        this.y = (elm.offsetTop+20);
    }
       // - (event.srcElement.parentElement.parentElement.offsetLeft));
      // return false;
    // this.contextMenu.setCoordinates();
    // this.contextMenu.toggle();
    // @ts-ignore
    if(ProjectLevelUtil.getLevel(event.currentTarget.dataset.nodeType) !== (ProjectLevelUtil.getLevel(this.targetName)+1)) {
      // modal alert
      this._modalTitle = 'JuJu Explorer';
      // @ts-ignore
      switch (event.currentTarget.dataset.nodeType) {
        case 'questionnaire' : if(this.targetName!=='project') {this._modalText = 'Questionnaire can only be imported from project level.';}break;
        case 'terminal' : if(this.targetName!=='questionnaire') {this._modalText = 'Terminals can only be imported from Questionnaire level.';}break;
        case 'file' : if(this.targetName!=='terminal') {this._modalText = 'Specific files can only be imported from Terminal level.';}break;
      }
      this._statusCode=250;
      this._hide = false;
      console.log('Only Questionnaire can be imported at project level' + this._hide);
      return;
    }
    this.showContext = true;
   /* context.style.left=+'px';
    context.style.top=+'px';*/
    /*this.x = ((event.clientX+100<window.innerWidth-window.innerWidth*0.03)?(event.clientX+2):(event.clientX-100-2)); // event.pageX;
    this.y = ((event.clientY+100<window.innerHeight-window.innerWidth*0.03)?(event.clientY+2):(event.clientY-100-2));*/// event.pageY;
  }

  hideContext() {
    this.showContext  = false;
  }

  onImport() {
    console.log(this.targetName);
    this.showContext = false;
    if(this.targetName === 'project') { // we are at a project level. The project exists
      this.importModal.toggle();
      this.importModal.setProjectLevel(ProjectLevel.Questionnaire);
      // modal with options
      // console.log(this._selectedProject.id+'/'+this._selectedQuestionnaire.id+'/'+this._selectedTerminal.id+'/'+this._selectedFile.src);
    }
    if(this.targetName === 'questionnaire') { // we are at questionnaire level. The questionnaire exists already
      this.importModal.toggle();
      this.importModal.setProjectLevel(ProjectLevel.Terminal);
      // modal with options
      // console.log(this._selectedProject.id+'/'+this._selectedQuestionnaire.id+'/'+this._selectedTerminal.id+'/'+this._selectedFile.src);
    }
    if(this.targetName === 'terminal') { // We are within a terminal
      this.importModal.toggle();
      this.importModal.setProjectLevel(ProjectLevel.File);
      // modal with options
      // console.log(this._selectedProject.id+'/'+this._selectedQuestionnaire.id+'/'+this._selectedTerminal.id+'/'+this._selectedFile.src);
    }


  }

  onOk() {
    if(this._statusCode===250) {
      this._hide = true;
      return;
    }
    this._hide = true;
    // document.location.reload(true);
    this._refreshService.refresh(true);
  }

  onExecuteImport(importOpt:ImportOption) {
    const importSpec = new ImportRequirement();

    importSpec.pId = this.selectedProject.id;
    importSpec.qId = this.selectedQuestionnaire.id;
    if(this.targetName === 'questionnaire' || this.targetName === 'terminal') {
      importSpec.tId = this.selectedTerminal.id;
      importSpec.terminalType = String(TerminalUtil.getTerminalTypeId(this.selectedTerminal.type));
    }
    importSpec.importMode = importOpt;

    const newQuest = new Questionnaire();
    newQuest.projectId = Number(this.context.project.id);

    switch(importOpt) {
      case ImportOption.Full: console.log('Import Questionnaire or Terminal completely with all its children');
        if(this.targetName === 'project') {
          this._projectService.createQuestionnaire(newQuest,importSpec).subscribe(data => {

                if(data === 100) {
                  this._statusCode = 200;
                  this._modalText = 'Questionnaire was imported successfully.';
                  this._modalTitle = 'Terminal';
                  this._hide = false;
                } else if(102) {
                  this._statusCode = data;
                  this._modalText = 'An error has occurred while importing questionnaire.';
                  this._modalTitle = 'Terminal';
                  this._hide = false;
                }
              },
              error => {
                console.log('Error create questionnaire');
                this._statusCode = 301;
                this._modalText = 'An error has occurred while creating questionnaire.';
                this._modalTitle = 'Questionnaire';
                this._hide = false;
              });
        } else if(this.targetName === 'questionnaire') {
          const term = new Terminal();
          term.associatedQuestionnaireId = this.context.qId;
          this._projectService.createTerminal(term,this.context.qId,importSpec).subscribe(data => {
                const rep = data as  Response;
                if(rep==null) {
                  console.log('Error while creating terminal');
                  this._statusCode = 406;
                  this._modalText = 'An error has occurred while importing terminal.';
                  this._modalTitle = 'Terminal';
                  this._hide = false;
                } else {
                  this._statusCode = 200;
                  this._modalText = 'Terminal was successfully imported.';
                  this._modalTitle = 'Terminal';
                  this._hide = false;
                }
              },
              error => {
                console.log('Error updating terminal');

                this._statusCode = 301;
                this._modalText = 'An error has occurred while importing terminal.';
                this._modalTitle = 'Terminal';
                this._hide = false;
              });
        } else if (this.targetName === 'terminal') {
          const term = new Terminal();
          term.associatedQuestionnaireId = this.context.qId;
          term.id = this.context.tId;
          this._projectService.updateTerminalNode(term,this.context.project.id,this.context.qId,this.context.terminalTypeId,importSpec).subscribe(data => {
                if(data === 100) {
                  this._statusCode = 200;
                  this._modalText = 'Terminal has been successfully imported.';
                  this._modalTitle = 'Terminal';
                  this._hide = false;
                } else if (102) {
                  this._statusCode = data;
                  this._modalText = 'An error has occurred while importing terminal.';
                  this._modalTitle = 'Terminal';
                  this._hide = false;
                }
              },
              error => {
                console.log('Error importing terminal');

                this._statusCode = 301;
                this._modalText = 'An error has occurred while importing terminal.';
                this._modalTitle = 'Terminal';
                this._hide = false;
              });
        }break;
      case ImportOption.Only: console.log('Import Questionnaire only, Terminal only or just a file or folder from the terminal directory');

        if(this.targetName === 'project') {
          this._projectService.createQuestionnaire(newQuest,importSpec).subscribe(data => {
                if(data === 100) {
                  this._statusCode = 200;
                  this._modalText = 'Questionnaire has been successfully imported..';
                  this._modalTitle = 'Questionnaire';
                  this._hide = false;
                } else if (102) {
                  this._statusCode = data;
                  this._modalText = 'An error has occurred while importing questionnaire.';
                  this._modalTitle = 'Questionnaire';
                  this._hide = false;
                }
              },
              error => { console.log('Error create client');
                this._statusCode = 301;
                this._modalText = 'An error has occurred importing questionnaire.';
                this._modalTitle = 'Terminal';
                this._hide = false;
              });
        } else if(this.targetName === 'questionnaire') {
          const term = new Terminal();
          term.associatedQuestionnaireId = this.context.qId;
          this._projectService.createTerminal(term,this.context.qId,importSpec).subscribe(data => {

                const rep = data as Response;
                if(rep!=null) {
                  this._statusCode = 200;
                  this._modalText = 'Terminal has been successfully imported.';
                  this._modalTitle = 'Terminal';
                  this._hide = false;
                } else if (rep.status === 406) {
                  this._statusCode = data;
                  this._modalText = 'An error has occurred while importing terminal or single resource.';
                  this._modalTitle = 'Terminal';
                  this._hide = false;
                }
              },
              error => {
                console.log('Error create client');
                this._statusCode = 301;
                this._modalText = 'An error has occurred importing questionnaire.';
                this._modalTitle = 'Terminal';
                this._hide = false;
              });
        } else if (this.targetName === 'terminal') {
          const term = new Terminal();
          term.associatedQuestionnaireId = this.context.qId;
          term.id = this.context.tId;
          importSpec.fileToDownload = this._selectedFile;
          this._projectService.updateTerminalNode(term,this.context.project.id,this.context.qId,this.context.terminalTypeId,importSpec).subscribe(data => {
                if(data === 100) {
                  this._statusCode = 200;
                  this._modalText = 'Terminal has been successfully updated.';
                  this._modalTitle = 'Terminal';
                  this._hide = false;
                } else if (102) {
                  this._statusCode = data;
                  this._modalText = 'An error has occurred while updating terminal.';
                  this._modalTitle = 'Terminal';
                  this._hide = false;
                }
              },
              error => {
                console.log('Error create client');
                this._statusCode = 301;
                this._modalText = 'An error has occurred importing questionnaire.';
                this._modalTitle = 'Terminal';
                this._hide = false;
              });
        }
        break;
      case ImportOption.TerminalAndAssets: console.log('Import Terminal with assets');
        if(this.targetName === 'project') {
          this._projectService.createQuestionnaire(newQuest,importSpec).subscribe(data => {
                if(data === 100) {
                  this._statusCode = 200;
                  this._modalText = 'Questionnaire has been successfully updated.';
                  this._modalTitle = 'Questionnaire';
                  this._hide = false;
                } else if (102) {
                  this._statusCode = data;
                  this._modalText = 'An error has occurred while importing questionnaire.';
                  this._modalTitle = 'Questionnaire';
                  this._hide = false;
                }
              },
              error => {
                console.log('Error create client');
                this._statusCode = 301;
                this._modalText = 'An error has occurred importing questionnaire.';
                this._modalTitle = 'Terminal';
                this._hide = false;
              });
        } else if(this.targetName === 'questionnaire') {
          const term = new Terminal();
          term.associatedQuestionnaireId = this.context.qId;
          this._projectService.createTerminal(term,this.context.qId,importSpec).subscribe(data => {

                const rep  = data as Response;
                if(rep != null) {
                  this._statusCode = 200;
                  this._modalText = 'Terminal has been successfully imported.';
                  this._modalTitle = 'Terminal';
                  this._hide = false;
                } else if (rep.status == null) {
                  this._statusCode = data;
                  this._modalText = 'An error has occurred while importing terminal.';
                  this._modalTitle = 'Terminal';
                  this._hide = false;
                }
              },
              error => {
                console.log('Error create client');
                this._statusCode = 301;
                this._modalText = 'An error has occurred importing questionnaire.';
                this._modalTitle = 'Terminal';
                this._hide = false;
              });
        }
        break;
      case ImportOption.TerminalAndPostSynchro: console.log('Import Terminal with Post Synchro');
        if(this.targetName === 'project') {
          this._projectService.createQuestionnaire(newQuest,importSpec).subscribe(data => {
                if(data === 100) {
                  this._statusCode = 200;
                  this._modalText = 'Questionnaire has been successfully imported.';
                  this._modalTitle = 'Terminal';
                  this._hide = false;
                } else if (102) {
                  this._statusCode = data;
                  this._modalText = 'An error has occurred while importing terminal.';
                  this._modalTitle = 'Questionnaire';
                  this._hide = false;
                }
              },
              error =>  {
                console.log('Error importing questionnaire');
                this._statusCode = 301;
                this._modalText = 'An error has occurred importing questionnaire.';
                this._modalTitle = 'Questionnaire';
                this._hide = false;
              });
        } else if(this.targetName === 'questionnaire') {
          const term = new Terminal();
          term.associatedQuestionnaireId = this.context.qId;
          this._projectService.createTerminal(term,this.context.qId,importSpec).subscribe(data => {
                const rep = data as Response;
                if(rep != null) {
                  this._statusCode = 200;
                  this._modalText = 'Terminal has been successfully imported.';
                  this._modalTitle = 'Terminal';
                  this._hide = false;
                } else if (rep == null) {
                  this._statusCode = 301;
                  this._modalText = 'An error has occurred while importing terminal. Verify that you have defined a questionnaire.';
                  this._modalTitle = 'Terminal';
                  this._hide = false;
                }
              },
              error => {
                console.log('Error importing terminal');
                this._statusCode = 301;
                this._modalText = 'An error has occurred importing questionnaire.';
                this._modalTitle = 'Questionnaire';
                this._hide = false;
              });
        }
        break;
    }
  }

  prepareDeviceView() {
    this.ListOfRegisteredDevices = true;
  }


  preparePreview(src: string) {

    const link = ServerAddress.getInstance().getValue()+'projects/'+this.selectedProject.id+'/'+this.selectedQuestionnaire.id+'/'+this.selectedTerminal.type.toLowerCase()+'/'+this.selectedTerminal.id+'/'+src;
    // this.notepadComponent.previewFile(this.selectedProject.id,this.selectedQuestionnaire.id,this.selectedTerminal.id,TerminalUtil.getTerminalTypeId(this.selectedTerminal.type),src);
    this.notepadComponent.setResourceLink(link);
    this.notepadComponent.toggleDialog();
  }
}
